import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        "data-slot": "item-separator",
        class: _normalizeClass($setup.cn('h-px bg-border', $setup.props.class))
    }, null, 2 /* CLASS */));
}
